import styled, { css } from 'styled-components';
import { getTextStyle } from 'utils/getTextStyle';

const PaymentSummary = styled('p')`
    ${getTextStyle('H5')};
    margin-top: 0;
    margin-bottom: 0;
`;
const PaymentSub = styled('p')`
    ${getTextStyle('BodySmall')};
    margin-top: 0;
    margin-bottom: 0;
`;

const Line = styled('div')`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
`;

const PaymentSummaryBlue = styled('span')`
    ${({ theme }) => css`
        color: ${theme.colors.primary.primary9};
    `}
`;

type Props = {
    mainTitle: string | number;
    mainValue: string | number;
    subtitle?: string | number;
    subtitleValue?: string | number;
    subtitle2?: string | number;
    subtitleValue2?: string | number;
};

export const SummaryText = ({
    mainTitle,
    mainValue,
    subtitle,
    subtitleValue,
    subtitle2,
    subtitleValue2,
}: Props) => (
    <Line>
        <PaymentSummary>
            {mainTitle} <PaymentSummaryBlue>{mainValue}</PaymentSummaryBlue>
        </PaymentSummary>
        <PaymentSub>
            {subtitle} <PaymentSummaryBlue>{subtitleValue}</PaymentSummaryBlue>
        </PaymentSub>
        <PaymentSub>
            {subtitle2} <PaymentSummaryBlue>{subtitleValue2}</PaymentSummaryBlue>
        </PaymentSub>
    </Line>
);
